module.exports = __webpack_public_path__ + "img/user.be1c51f8.png";